/* TODO: refactor all remaining ultrasearch functions into instances of Soup Mail autocomplete control  (or Soup Mail searchfilter control) */

$ultrasearch = {
	
	// constants
	requestDelay : 250,					// minimum delay time (milliseconds) between HTTP requests, so as to not overload the server
	$ultraSearchRequestAfterNumCharacters : 3,		// after the user has typed this many characters into the box, it does a HTTP request straightaway, regardless of the timer
	
	// init variables
	timer : 0,
	obj : 0,
	lastDashboardUltraSearch : '',
	lastFolderManagerUltraSearch : '',

	methods: {
        ultraSearch: function ($obj) {

            jQuery('.soupmail-main-list').fadeTo(50, 0.3);

            // the user is currently typing in the search box... we implement a timer here so that we're not overloading the server with a billion requests
            $ultrasearch.obj = $obj;
            clearTimeout($ultrasearch.timer);
            $views.main.refineSearchHighlight = true;

            if (jQuery($obj).val().length == 0) {
                jQuery('#mod-search-searchword').css({'color': '#c2c2c2'});
                jQuery('#ultraSearchResults ul').remove();
                jQuery('.soupmail-main-list').fadeTo(50, 1.0);
                jQuery('#searchbox-highlight').hide();
                jQuery('#searchbox-typing-cancel').hide();

                $models.main.currentEmailsListOffset = 0;
                $models.main.getEmailsList();

            } else {
                jQuery('#mod-search-searchword').css({'color': '#000'});
                jQuery('#searchbox-typing-cancel').show();
                jQuery('#searchbox-highlight').show();
                $ultrasearch.timer = setTimeout('$ultrasearch.methods.ultraSearchRequest()', $ultrasearch.requestDelay);
            }
        },

        ultraSearchRequest: function () {
			// the user has paused typing and now it's time to show some results... fetch them from the server
			clearTimeout($ultrasearch.timer);

			if (jQuery($ultrasearch.obj).val()) {
				$soupmail.helpers.filter.$filters.specificEmailFilter = '';	// first remove any "Specific Email" filter
				$soupmail.helpers.filter.rebuildFilterByBar();
				$soupmail.helpers.filter.toggleClearFilterButton();
				$models.main.currentEmailsListOffset = 0;
				$models.main.getEmailsList();
			}
		},

        mobileEmailSearch: function($params, $obj) {
            jQuery('.soupmail-main-list').fadeTo(50, 0.3);

            // the user is currently typing in the search box... we implement a timer here so that we're not overloading the server with a billion requests
            $ultrasearch.obj = $obj;
            clearTimeout($ultrasearch.timer);

            if (jQuery($obj).val().length == 0) {
                jQuery('.soupmail-main-list').fadeTo(50, 1.0);
                jQuery('#searchbox-typing-cancel').hide();

                $models.mobile_emails.currentEmailsListOffset = 0;
                $controllers.mobile_emails.display($params);

            } else {
                jQuery('#searchbox-typing-cancel').show();
                $ultrasearch.timer = setTimeout($ultrasearch.methods.mobileEmailSearchRequest($params), $ultrasearch.requestDelay);
            }
		},

        mobileEmailSearchRequest: function($params) {

        	// the user has paused typing and now it's time to show some results... fetch them from the server
            clearTimeout($ultrasearch.timer);

            if (jQuery($ultrasearch.obj).val()) {
                $models.mobile_emails.currentEmailsListOffset = 0;
                $models.mobile_emails.getEmailsList($params);
            }
		},

        mobileFolderSearch: function($obj) {
            jQuery('.folder-list').fadeTo(50, 0.3);

            // the user is currently typing in the search box... we implement a timer here so that we're not overloading the server with a billion requests
            $ultrasearch.obj = $obj;
            clearTimeout($ultrasearch.timer);

            if (jQuery($obj).val().length == 0) {
                jQuery('.folder-list').fadeTo(50, 1.0);
                jQuery('#searchbox-typing-cancel').hide();

                $models.mobile_folders.currentFoldersListOffset = 0;
                $models.mobile_folders.getFoldersList();

            } else {
                jQuery('#searchbox-typing-cancel').show();
                $ultrasearch.timer = setTimeout('$ultrasearch.methods.mobileFolderSearchRequest()', $ultrasearch.requestDelay);
            }
		},

        mobileFolderSearchRequest: function() {

            // the user has paused typing and now it's time to show some results... fetch them from the server
            clearTimeout($ultrasearch.timer);

            if (jQuery($ultrasearch.obj).val()) {
                $models.mobile_folders.currentFoldersListOffset = 0;
                $models.mobile_folders.getFoldersList();
            }
		}

	}

};


// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.ultrasearch.js